<mat-nav-list>
  <ng-container *ngFor="let button of buttons">
    <app-sidebar-button
      [button]="button"
      [isExpanded]="isExpanded"
      (buttonClick)="onButtonClick($event)"
    ></app-sidebar-button>
  </ng-container>
</mat-nav-list>
